"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = require("prop-types");
var _default = exports["default"] = (0, _propTypes.shape)({
  _id: _propTypes.string.isRequired,
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]).isRequired,
  type: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]).isRequired,
  hidden: _propTypes.bool.isRequired,
  muted: _propTypes.bool,
  title: _propTypes.string.isRequired
});